<!-- eslint-disable vue/no-mutating-props -->
<template>
    <Dialog v-model:visible="editItemDialog" :style="{width: '450px'}" header="Data Detail" :modal="true" class="p-fluid">
         <div class="field">
            <label>Beat</label>
            <InputText v-model="item.beat_name" required="true" autofocus :class="{ 'p-invalid': errorEdit.beat_name }"/>
            <small class="p-invalid" style="color: red" v-if="errorEdit.beat_name" >{{ errorEdit.beat_name[0] }}</small >
        </div>
        <div class="field">
            <label>Distributor</label>
            <Dropdown dataKey="label" 
                    ref="ddist" v-model="item.db_id" 
                    :loading="loadingDropdownDistributor" 
                    :options="dataDropdownDistributor" 
                    :class="{ 'p-invalid': errorEdit.db_id }" 
                    optionLabel="label" optionValue="db_id" 
                    placeholder="Select Distributor" :filter="true" 
                    :showClear="true" @filter="searchDropdownDistributor($event,'edit')"
                    @change="changeCity()"
            />
            <small class="p-invalid" style="color: red" v-if="errorEdit.db_id" >{{ errorEdit.db_id[0] }}</small>
        </div>
        <div class="field">
            <label>City</label>
            <Dropdown dataKey="city_id" 
                    ref="dcity" v-model="item.city_id" 
                    :loading="loadingDropdownCity" 
                    :options="dataDropdownCity" 
                    :class="{ 'p-invalid': errorEdit.city_id }" 
                    optionLabel="label" optionValue="city_id" 
                    placeholder="Select City" :filter="true" 
                    :showClear="true" @filter="searchDropdownCity($event,'edit')"
            />
            <small class="p-invalid" style="color: red" v-if="errorEdit.city_id" >{{ errorEdit.city_id[0] }}</small>
        </div>
         <div class="field">
            <label>Beat Status</label>
            <Dropdown v-model="item.beat_status" :options="dataDropdownStatus" optionLabel="name" optionValue="code" placeholder="Select Status" :class="{ 'p-invalid': errorEdit.beat_status }"/>
                <small class="p-invalid" style="color: red" v-if="errorEdit.beat_status" >{{ errorEdit.beat_status[0] }}</small>
        </div>
        <template #footer>
            <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
            <Button label="Update" icon="pi pi-check" class="p-button-text" @click="updateItem" :loading="loading"/>
        </template>
    </Dialog>
</template>


<script>

import { mapGetters } from "vuex";

export default {
    props: [
		"item",
    ],
    data() {
        return {
            // loading
            loading: false,
            loadingDropdownDistributor: false,
            loadingDropdownCity: false,

            // dataDropdown
            dataDropdownDistributor: null,
            dataDropdownCity: null,
            dataDropdownStatus: [
                {name: 'ACTIVE', code: 'y'},
                {name: 'NON ACTIVE', code: 'n'},
            ],

            // edit
            editItemDialog: false,
        }
    },
    mounted() {
        this.$store.commit('setErrorEdit', {});
    },
    watch: {
        editItemDialog: {
            handler() {
                setTimeout(() => {
                    if(this.editItemDialog == true){
                        this.searchDropdownDistributor('', 'edit', this.item.db_code +"-"+ this.item.db_name );
                        this.searchDropdownCity('', 'edit', this.item.territory_name +"-"+ this.item.city_name );
                    }
                    this.$store.commit('setErrorEdit', {});
                }, 500);
            },
        }
    },
    computed:{
        ...mapGetters(['errorEdit']),
		...mapGetters("auth", ["user"]),
    },
    methods: {
        // DROPDOWN
        searchDropdownDistributor(event, purpose, valueEdit){
            setTimeout(() => {
                if(valueEdit){
                    this.$refs.ddist.filterValue = valueEdit;
                }

                if(purpose == "edit"){
                    this.loadingDropdownDistributor = true;
                }

                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/select2/master-distributor',
                    params: {
                        "search" : valueEdit ? valueEdit : event.value,
                    }
                })
                .then(res => {

                    if(purpose == "edit"){
                        this.dataDropdownDistributor = res.data.data;
                        this.loadingDropdownDistributor = false;
                    }else if(purpose == null){
                        this.dataDropdownDistributor = res.data.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            }, 250);
        },
        changeCity() {
            // eslint-disable-next-line vue/no-mutating-props
            this.item.city_id = null;
            this.dataDropdownCity = null;
            this.searchDropdownCity('');
        },
        searchDropdownCity(event, purpose, valueEdit){
            setTimeout(() => {
                if(this.item.db_id){
                    if(valueEdit){
                        this.$refs.dcity.filterValue = valueEdit;
                    }

                    if(purpose == "edit"){
                        this.loadingDropdownCity = true;
                    }

                    this.axios({
                        method: 'GET',
                        url: process.env.VUE_APP_ROOT_API + 'web/select2/master-city4',
                        params: {
                            "search" : valueEdit ? valueEdit : event.value,
                            "db_id" : this.item.db_id
                        }
                    })
                    .then(res => {

                        if(purpose == "edit"){
                            this.dataDropdownCity = res.data.data;
                            this.loadingDropdownCity = false;
                        }else if(purpose == null){
                            this.dataDropdownCity = res.data.data;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
                }
            }, 250);
        },
        // EDIT
		hideDialog() {
			this.editItemDialog = false;
		},
		updateItem() {
            this.loading = true;

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/beat/update',
                data: {
                    "beat_id": this.item.beat_id,
                    "beat_name": this.item.beat_name,
                    "db_id": this.item.db_id,
                    "city_id": this.item.city_id,
                    "beat_status" : this.item.beat_status,
                },
            })
            .then((res) => {
                this.loading = false;
                if (res) {
                    this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Successfully Saved', life: 3000,});
                    this.$store.commit('setErrors', {});
                    this.$store.commit('setErrorEdit', {});
                    // this.item = {};
                    this.editItemDialog = false;
                    this.$emit('submit');
                }
            })
            .catch((err) => {
                console.log(err);
                this.loading = false;
                this.$store.commit('setErrorEdit', err.response.data.data);
                this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Failed to Saved', life: 3000,});
            });
		},
    }
}
</script>